import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useCallback, useEffect } from 'react';
import { useId, useObjectRef } from '@react-aria/utils';
import { BKJButton } from '../BKJButton/index.js';
import { BKJDialogWrapper, Title, Text, CloseIcon, ButtonGroup, TextWrapper, CloseIconWrapper, } from './BKJDialog.styled.js';
const CancelVariantMap = {
    Danger: 'PurpleOutlined',
    Default: 'PurpleOutlined',
};
const ActionVariantMap = {
    Danger: 'RedSolid',
    Default: 'PurpleSolid',
};
export const BKJDialog = forwardRef(({ variant, title, text, cancelLabel, actionLabel, onAction, onCancel, onClose, ...rest }, forwardedRef) => {
    const wrapperRef = useObjectRef(forwardedRef);
    const titleId = useId();
    const handleKeyUp = useCallback((event) => {
        if (event.key === 'Escape') {
            onClose();
        }
    }, [onClose]);
    useEffect(() => {
        document.addEventListener('keyup', handleKeyUp);
        return () => {
            document.removeEventListener('keyup', handleKeyUp);
        };
    }, [handleKeyUp]);
    useEffect(() => {
        const previouslyFocused = document.activeElement;
        wrapperRef.current?.focus();
        return () => {
            previouslyFocused?.focus();
        };
    }, [wrapperRef]);
    return (_jsxs(BKJDialogWrapper, { role: "dialog", "aria-modal": "true", "aria-labelledby": titleId, tabIndex: -1, ...rest, variant: variant, ref: wrapperRef, children: [_jsx(CloseIconWrapper, { onClick: onClose, type: "button", "aria-label": "Close", children: _jsx(CloseIcon, { iconName: "CloseBold" }) }), _jsxs(TextWrapper, { children: [_jsx(Title, { id: titleId, children: title }), _jsx(Text, { children: text })] }), _jsxs(ButtonGroup, { children: [_jsx(BKJButton, { variant: CancelVariantMap[variant], onClick: onCancel, children: cancelLabel }), _jsx(BKJButton, { variant: ActionVariantMap[variant], onClick: onAction, children: actionLabel })] })] }));
});
//# sourceMappingURL=BKJDialog.js.map